import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import * as Icon from "react-bootstrap-icons"
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from "../../Common/Skeleton";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import View from '../../../Assets/View.svg';
import Edit from '../../../Assets/Edit.svg';
import Delete from '../../../Assets/Delete.svg';
import { setLogout } from '../../Auth/LoginSlice';
import { setActiveKey } from '../../Common/ActiveKeySlice';
import useDebouncedApiCall from '../../Common/Reuse/Debounce';
import DeleteModel from '../../Common/Model/DeleteModel';
import PaginationSequence from '../../Common/Pagination/PaginationSequence';
import PublishModel from '../../Common/Model/PublishModel';
import UnPublishModel from '../../Common/Model/UnPublishModel';
import { setPageNo, setDocPerPage, resetData } from '../../Common/PaginationSlice';

const PageList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userState = useSelector((state) => state?.cmsLogin?.userData.data);

    // for pagination
    const pageNo = useSelector((state) => state.pagination.pageNo);
    const docPerPage = useSelector((state) => state.pagination.docPerPage);

    const [listLoader, setListLoader] = useState(false);
    const [isdelete, setIsDelete] = useState(false);

    const [deleteId, setDeleteId] = useState("");
    const [page, setPage] = useState("")
    const [searchField, setSearchField] = useState("");

    const [AllPage, setAllPage] = useState([])

    // for no of pages
    const [noOfPages, setNoOfPages] = useState();

    const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
    const [publishpageId, setPublishPageId] = useState(null);

    // Unpublish video variables
    const [isUnpublish, setIsUnpublish] = useState(false);
    const [unpublishId, setUnpublishId] = useState("");

    // Function for handling page change
    const handlePageChange = (pageNumber) => {
        dispatch(setPageNo(pageNumber));
    };

    // Function for handling docsper page change
    const handleDocsPerPage = (docsPageProp) => {
        dispatch(setPageNo(1));
        dispatch(setDocPerPage(docsPageProp));
    };


    // Function to handle opening the publish modal
    const openPublishModal = (pageId) => {
        setPublishPageId(pageId);
        setIsPublishModalOpen(true);
    };

    // Function to handle opening the unpublish modal
    const openUnpublishModal = (pageId) => {
        setUnpublishId(pageId);
        setIsUnpublish(true);
    };

    // Function to handle cancelling the unpublish modal
    const closeUnpublishModal = () => {
        setIsUnpublish(false);
    };

    const handlePublishModalCancel = () => {
        setIsPublishModalOpen(false);
    };


    useEffect(() => {
        getAllPageData()
    }, [docPerPage, pageNo])

    // for get all page data
    const getAllPageData = async () => {
        setListLoader(true)
        const payload = {
            documentsPerPage: docPerPage,
            page: pageNo,
            title: searchField ? searchField : ""
        }
        await fetch(process.env.REACT_APP_BASE_URL + "/page/getAllPagesPGN", {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.message === "Authorization failed / Forbidden") {
                    setListLoader(true);
                    dispatch(setLogout(null));
                    dispatch(setActiveKey(null));
                    localStorage.removeItem('persist:root');
                    navigate('/');
                } else {
                    setAllPage(response)
                    setNoOfPages(response?.noOfPages);
                    setListLoader(false)
                }

            })
            .catch((error) => {
                setListLoader(false)
                console.log("error", error);
            })
    }


    // for custome hook call
    const dependencies = [page ? page : "", searchField ? searchField : ""];
    useDebouncedApiCall(getAllPageData, dependencies, setListLoader);

    // for delete page
    const deletePage = async () => {
        const payload = {
            pageId: deleteId
        }
        await fetch(process.env.REACT_APP_BASE_URL + "/page/deletePage", {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.message === "Page deleted successfully") {
                    toast.success("Deleted successfully.")
                    setIsDelete(false)
                    getAllPageData()
                }
            }).catch((error) => {
                console.log("error", error);
            })
    }

    // for toggle
    const handlePublishAction = async (pageId, isPublish) => {

        try {
            setIsPublishModalOpen(false);
            setIsUnpublish(false);

            const result = await fetch(process.env.REACT_APP_BASE_URL + "/page/publishPage", {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${userState.token}` },
                body: JSON.stringify({
                    pageId: pageId,
                    isPublish: isPublish
                }),
            });

            const response = await result.json();
            if (response) {
                getAllPageData();
            } else {
                console.log("Error toggling publish status");
            }
        } catch (error) {
            console.log(error);
        }
    };
    // Function to handle confirming publish modal
    const handlePublishModalConfirm = async () => {
        await handlePublishAction(publishpageId, true);
    };

    // Function to handle confirming unpublish modal
    const handleUnpublishConfirm = async () => {
        await handlePublishAction(unpublishId, false);
    };

    return (
        <>
            <div className="outletPadding">

                <PublishModel
                    isOpen={isPublishModalOpen}
                    onClose={handlePublishModalCancel}
                    onConfirm={handlePublishModalConfirm}
                    title="Page"
                    loader={listLoader}
                />
                <UnPublishModel
                    isOpen={isUnpublish}
                    onClose={closeUnpublishModal}
                    onConfirm={handleUnpublishConfirm}
                    title="Page"
                    loader={listLoader}
                />

                {/* Delete Article */}
                <DeleteModel
                    show={isdelete}
                    onHide={() => setIsDelete(false)}
                    onDelete={deletePage}
                    loader={listLoader}
                    label="Page"
                />
                <Container>
                    <Row className="d-flex justify-content-between">
                        <Col md={4} className='mb-3 mb-md-0'>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search here"
                                name="search"
                                value={searchField}
                                onChange={(e) => {
                                    if (e.target.value.trim()) {
                                        setSearchField(e.target.value)
                                        dispatch(setPageNo(1));
                                    } else if (e.target.value.length === 0) {
                                        setSearchField(e.target.value)
                                        dispatch(setPageNo(1));
                                    }
                                }}
                            />
                        </Col>

                        <Col md={4} className="d-flex justify-content-end align-items-center">
                            <div className='d-flex flex-row'>
                                <Button className="primaryBtn w-100 my-auto" onClick={() => {
                                    dispatch(resetData());
                                    navigate("/dashboard/add-page")
                                }}>
                                    <Icon.PlusCircle className="me-2" size={15} />
                                    Add Page
                                </Button>
                            </div>
                        </Col>

                    </Row>

                    {/* category List Table */}
                    <div className="outer-wrapper mx-auto mt-4">
                        <div className="table-wrapper" style={{ maxHeight: "68vh" }}>
                            <table>
                                <thead>
                                    <th>Sr. No.</th>
                                    <th>Page Icon</th>
                                    <th>Page Name</th>
                                    <th>Page Type</th>
                                    <th>Publish</th>
                                    <th>Action</th>
                                </thead>
                                {listLoader ? (
                                    <Skeleton rows={10} cols={6} />
                                ) : AllPage?.data?.length > 0 && AllPage?.data !== null && AllPage?.data !== undefined ? (
                                    AllPage?.data?.map((itm, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{pageNo !== 1 ? (<>{index + 1 + docPerPage * (pageNo - 1)}</>) : (<>{index + 1}</>)}</td>
                                                <td><img src={itm?.iconURL} alt="Page Icon" width={40} /></td>
                                                <td style={{ width: "18vw" }}>{itm?.pageName}</td>
                                                <td>{itm?.pageType}</td>
                                                <td style={{ width: '120px' }}>
                                                    {itm.isPublish ? (
                                                        <div
                                                            style={{
                                                                backgroundColor: "#8FBC8F",
                                                                borderRadius: "8px",
                                                                padding: "4px 8px",
                                                                color: "white",
                                                                textAlign: "center",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => openUnpublishModal(itm.pageId)}
                                                        >
                                                            Published
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="switch"
                                                            onClick={() => openPublishModal(itm.pageId)}
                                                        >
                                                            <input type="checkbox" checked={itm.publish} onChange={() => { }} />
                                                            <span className="slider round" onClick={() => openPublishModal(itm.pageId)}></span>
                                                        </div>
                                                    )}

                                                </td>
                                                <td className="d-flex">
                                                    <img src={View} alt="View" className="icon me-3"
                                                        onClick={() => navigate("/dashboard/view-page", {
                                                            state: { page: itm }
                                                        })
                                                        } />

                                                    <img src={Edit} alt="Edit" className="icon me-3"
                                                        onClick={() => navigate("/dashboard/edit-page", { state: { item: itm } })}
                                                    />

                                                    <img src={Delete} alt="Delete" className='icon'
                                                        onClick={() => {
                                                            setIsDelete(true);
                                                            setDeleteId(itm?.pageId);
                                                        }} />
                                                </td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <p className="noDataFound">No Data Found</p>
                                )}
                            </table>
                        </div>
                    </div>

                    <PaginationSequence
                        data={AllPage?.count}
                        pageNo={pageNo}
                        noOfPages={noOfPages}
                        handlePageChange={handlePageChange}
                        handleDocsPerPage={handleDocsPerPage}
                        docPerPage={docPerPage}
                    />
                </Container>

            </div>
        </>
    )
}

export default PageList
